import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
// import { TreeModule } from 'primeng';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api'
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { DatePipe } from '@angular/common';
import { QuickDeligationService } from 'src/app/_services/ApplicationServices/quick-delegation.service';
import { status, addAdvanceRequest, advanceChkWF, advanceDate, advanceDelegatee, advanceRemarks, listAddRole, listAddSubRole, QuickDeligation, recentDelegatee, setSubRole } from 'src/app/_services/ApplicationServices/quick-delegation';
import { catchError } from 'rxjs/operators';
import { SAPID } from 'src/app/_shared/common/global-variables';
import { CountryService } from 'src/app/_services/ReportServices/countryservice';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
//import { SafehtmlPipe } from 'src/app/safehtml.pipe';
import { NgxSpinnerService } from 'ngx-spinner';
import { WindowService } from 'src/app/_services/CommonServices/windowservice';

@Component({
  selector: 'app-advanced-delegation',
  templateUrl: './advanced-delegation.component.html',
  styleUrls: ['./advanced-delegation.component.css'],
  providers: [MessageService],
  standalone: false
})
export class AdvancedDelegationComponent implements OnInit {


  sucImg = "assets/images/tick.gif";


  // on keyup input close btn show
  searchTxt: string = '';
  closebtn: boolean = true;
  ingredient: any;
  rangeDates: any;
  changeEvt(e) {
    if (this.searchTxt != null || this.searchTxt != "") {
      this.closebtn = false;
    }
  }
  clearInput() {
    this.searchTxt = "";
    this.closebtn = true;
  }
  // on keyup input close btn show End

  // Class Active & Inactive Toggled
  delegateToggled = false;
  delegateHideDiv = false;
  public toggleDelegate() {
    this.delegateToggled = !this.delegateToggled;
    this.delegateHideDiv = !this.delegateHideDiv;
  }

  durationToggled = false;
  durationHideDiv = false;
  public toggleDuration() {
    this.durationToggled = !this.durationToggled;
    this.durationHideDiv = !this.durationHideDiv;
  }

  remarksToggled = false;
  remarksHideDiv = false;
  public toggleRemarks() {
    this.remarksToggled = !this.remarksToggled;
    this.remarksHideDiv = !this.remarksHideDiv;
  }
  // Class Active & Inactive Toggled End

  //range Calendar
  ranges: any = [{
    value: [new Date(new Date().setDate(new Date().getDate() + 30)), new Date()],
    label: '1 Month'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 91))],
    label: '3 Months'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 182))],
    label: '6 Months'
  }, {
    value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 365))],
    label: '1 Year'
  }
  ];


  // Show and Hide Div
  noData: boolean = true;
  addApps: boolean = false;
  selectApp: boolean = true;
  addSpoc() {
    this.addApps = true;
    this.selectApp = false;
    this.noData = false;
  }
  reAddSpoc() {
    this.addApps = false;
    this.selectApp = true;
  }

  addApps1: boolean = false;
  selectApp1: boolean = true;
  addSpoc1() {
    this.addApps1 = true;
    this.selectApp1 = false;
  }
  reAddSpoc1() {
    this.addApps1 = false;
    this.selectApp1 = true;
  }


  // Show and Hide Div
  billing: boolean = true;
  selectbilling: boolean = false;
  addSpocD() {
    this.billing = false;
    this.selectbilling = true;
  }

  addSpocD1() {
    this.billing = true;
    this.selectbilling = false;
  }

  // Show and Hide Div
  // addApps:boolean= false;
  // selectApp:boolean= true;
  // addSpoc() {
  // this.addApps= true;
  // this.selectApp=false;
  // }

  addSpocB() {
    this.addApps = false;
    this.selectApp = true;
  }



  // addApps1:boolean= false;
  // selectApp1:boolean= true;
  // addSpoc1() {
  // this.addApps1= true;
  // this.selectApp1=false;
  // }

  addSpocA() {
    this.addApps1 = false;
    this.selectApp1 = true;
  }
  // Show and Hide Div End



  // Show and Hide Div End

  //  Select all CheckBox
  mast = false;
  child1 = false
  child2 = false
  child3 = false
  child4 = false
  child5 = false
  child6 = false
  child7 = false
  master() {
    this.mast = this.mast;

    if (this.mast === true) {
      this.child1 = true
      this.child2 = true
      this.child3 = true
      this.child4 = true
      this.child5 = true
      this.child6 = true
      this.child7 = true
    }
    if (this.mast === false) {
      this.child1 = false
      this.child2 = false
      this.child3 = false
      this.child4 = false
      this.child5 = false
      this.child6 = false
      this.child7 = false
    }
  }
  child() {
    if (this.child1 === true && this.child2 === true && this.child3 === true && this.child4 === true
      && this.child5 === true && this.child6 === true && this.child7 === true) {
      this.mast = true;
    }
    else {
      this.mast = false;
    }
  }

  // Roles (without Sub-Roles)  Select all CheckBox
  mastR = false;
  role1 = false
  role2 = false
  role3 = false
  masterR() {
    this.mastR = this.mastR;
    if (this.mastR === true) {
      this.role1 = true
      this.role2 = true
      this.role3 = true
    }
    if (this.mastR === false) {
      this.role1 = false
      this.role2 = false
      this.role3 = false
    }
  }
  childR() {
    if (this.role1 === true && this.role2 === true && this.role3 === true) {
      this.mastR = true;
    }
    else {
      this.mastR = false;
    }
  }

  // Roles (along with Sub-Roles) Select all CheckBox
  mastR1 = false;
  lob1 = false
  lob2 = false
  masterR1() {
    this.mastR1 = this.mastR1;
    if (this.mastR1 === true) {
      this.lob1 = true
      this.lob2 = true
    }
    if (this.mastR1 === false) {
      this.lob1 = false
      this.lob2 = false
    }
  }
  childR1() {
    if (this.lob1 === true && this.lob2 === true) {
      this.mastR1 = true;
    }
    else {
      this.mastR1 = false;
    }
  }
  // BU Head Select all CheckBox
  mastR2 = false;
  bu1 = false
  masterR2() {
    this.mastR2 = this.mastR2;
    if (this.mastR2 === true) {
      this.bu1 = true
    }
    if (this.mastR2 === false) {
      this.bu1 = false
    }
  }
  childR2() {
    if (this.bu1 === true) {
      this.mastR2 = true;
    }
    else {
      this.mastR2 = false;
    }
  }

  // Expand and Collapse All
  index: number = null;
  //lastIndex = -2;
  txtTgl: boolean = true;
  openAll() {
    this.index = (this.index === 1) ? 0 : this.index + 1;
  }
  // Expand and Collapse All End


  // Success Alert Start
  showSuccess() {
    this.messageService.add({ severity: 'success', });
    setTimeout(() => {
      this.router.navigate(['/advanceDeligation']);
    }, 200);
  }
  // Success Alert End


  /* MODAL */
  modalRef: BsModalRef;
  // Alert 
  alertIcon = "assets/images/alert-01.svg";
  alert(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'alertM' })
    );
  }


  @ViewChild('validationTemp') templateRef: TemplateRef<any>;
  @ViewChild('rejectModal') public rejectModal: ModalDirective;
  @ViewChild('validTemp') templateRefsubmit2: TemplateRef<any>;
  @ViewChild('validOnBehalf') templateOnBehalfsubmit: TemplateRef<any>;
  @ViewChild('alertOnBehalf') templateOnBehalfalert: TemplateRef<any>;
  @ViewChild('validDate') templateDate: TemplateRef<any>;
  @ViewChild('validSubRoleSelected') templateSubRole: TemplateRef<any>;
  @ViewChild('validDelegatee') templatevalidDelegatee: TemplateRef<any>;
  @ViewChild('validonBehalfEmp') templatevalidonBehalfEmp: TemplateRef<any>;
  @ViewChild('validationuploadFile') templatevalidationuploadFile: TemplateRef<any>;
  @ViewChild('approvedModal') templateapprovedModal: TemplateRef<any>;
  @ViewChild('alertSuccErrorModal') templateSuccErrorModal: TemplateRef<any>;
  @ViewChild('alertSuccErrorModalMultiLine') templateSuccErrorModalMultiLine: TemplateRef<any>;

  minDate: Date;
  public myDatestring: string;
  myDate: Date;
  myDatestringthritydays: string;
  DateRange: string;
  searchText: string;
  currentPageUrl: boolean = false;
  errorMessage: string;
  appRoleAndSubRoles: QuickDeligation[] = [];
  recentDelegatee: recentDelegatee[] = [];
  filterRoleAndSubRole: any[] = [];
  selectedApps: QuickDeligation[] = [];
  appChoice: string;
  encValues: string = '';
  url: string;
  encSapId: string = '';
  encAppId: string = '';
  encDelReqID: string = '';
  createAdvanceDelegation: addAdvanceRequest[] = [];
  listAddRole: listAddRole[] = new Array;
  listAddSubRole: listAddSubRole[] = new Array;
  listchkWF: advanceChkWF[] = new Array;
  listRemarks: advanceRemarks[] = new Array;
  listDelegatee: advanceDelegatee[] = new Array;
  listDate: advanceDate[] = new Array;
  delegateeSapId: string;
  DelegationStartDate: string = null;
  DelegationEndDatetime: string = null;
  touchDate: Date = new Date();
  ActionBy: string = this.global.UserLoggedInSAPID;
  RequesterSAPId: string = this.global.UserLoggedInSAPID;
  advancedRemarks: string = "Due to non-availability in office";
  reqSubmitMessage: status[] = [];
  reqStatusRemarks: string = "";
  copyreqStatusRemarks: string = "";
  listSubRoleAsPerRoleSelection = [];
  listAddSubRoleAsperRoleSelection = [];
  brands: string[] = [''];
  filteredBrands: any[];
  brand: string[] = [''];
  uploadedDoc: any[] = [];
  public DelegatorChecked: boolean = false;
  hiddenBtn: boolean;
  selectedSubRoles: setSubRole[] = [];
  IsSubRoleApplication: boolean = false;
  NoOfSelectedApp: number;
  removeAppName: string;
  isCheckAllApp: boolean = false;
  SelectAllRoles: boolean = false;
  NoOfSelectedRoleWithoutSubRole: number;
  CheckwithoutRole: boolean = false;
  SelectAllSubRoles: boolean = false;
  public AdvanceDateRangeFilter: Date[];
  isDelegateeToggle = false;
  ValidationRoles: boolean = false;
  DelegatorConsen: boolean;
  remarkchecked = false;
  searchOnBehalfEmployee: string;
  Validationonbehalfemployee: boolean = false;
  Validationfileupload: boolean = false;
  ValidationSelectDelegetee: boolean = false;
  ValidationSubRoles: boolean = false;
  validRequest = true;
  isSubmitbuttonshow = false;
  listReqStatusRemarks: any;
  visible: any;
  errorOnAdvDelegation: string;
  errorOndehalfDelegation: string;
  errorOndehalfDelegationMultiError: any;
  alertImg = "assets/images/alert.svg";
  removedSubRoleslength: any[] = [];

  constructor(private global: GlobalService, private datePipe: DatePipe, private appInsights: AppInsightsService, private modalService: BsModalService,
    private loginService: LoginService, private messageService: MessageService, private router: Router, private advancedDelService: QuickDeligationService,
    private countryService: CountryService, private SpinnerService: NgxSpinnerService, private win: WindowService) {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());

    this.myDate = new Date();
    this.myDatestring = this.datePipe.transform(this.myDate, 'dd/MMM/yyyy');
    let thirtyday = (d => new Date(d.setDate(d.getDate() + 30)))(new Date);
    this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd/MMM/yyyy');

    this.AdvanceDateRangeFilter = [new Date, thirtyday];

    //this.DateRange = this.myDatestring + ' - ' + this.myDatestringthritydays;

    var date1 = new Date(this.myDatestring);
    var date2 = new Date(this.myDatestringthritydays);

    this.DelegationStartDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
    this.DelegationEndDatetime = this.datePipe.transform(date2, 'yyyy-MM-dd');

  }

  ngOnInit(): void {
    if (this.global.getSapId() == null) {
      this.global.redirectIfInvalidUser();
      return;
    }
    this.SpinnerService.show();
    //var onBehalfFlag = localStorage.getItem('Onbehalf');
    var onBehalfFlag = this.global.getOnBehalf;
    if (this.router.url.includes('On-Behalf-Delegation')) {
      this.currentPageUrl = true;
    }
    else {
      this.currentPageUrl = false;
    }
    this.appInsights.logPageView('Advance Delegation', '/AdvanceDelegation');
    if (this.global.UserLoggedInSAPID != undefined || this.global.UserLoggedInSAPID != null) {
      this.RequesterSAPId = this.global.UserLoggedInSAPID;
      this.ActionBy = this.global.UserLoggedInSAPID;
      this.getRecentDelegatee();
      this.getAllAppRoleAndSubRole();
    } else {
      this.myFirstOperation();
    }

  }

  myFirstOperation() {
    const result = this.loginService.GetDecryptCodeValue(this.global.getSapId());
    result.subscribe((result) => {
      this.global.UserLoggedInSAPID = result.cipherText;
      this.RequesterSAPId = this.global.UserLoggedInSAPID;
      this.ActionBy = this.global.UserLoggedInSAPID;
      this.getAllAppRoleAndSubRole();
    });
  }

  public getInitialDateFrom(): Date {
    return new Date();
  }

  getAllAppRoleAndSubRole() {
    this.SpinnerService.show();
    this.advancedDelService.fetchApplications().subscribe(
      {
        next: appRoles => {
          this.appRoleAndSubRoles = appRoles;
          this.SpinnerService.hide();
        },
        error: err => this.errorMessage = err
      }
    );
  }

  getRecentDelegatee() {
    this.advancedDelService.fetchRecentDelegatee().subscribe(
      {
        next: data => {
          this.recentDelegatee = data;

          // this.brands[0] = this.recentDelegatee[0].EmpName + ' (' + this.recentDelegatee[0].SAPID + ')';
          // this.brand[0] = this.recentDelegatee[0].EmpName + ' (' + this.recentDelegatee[0].SAPID + ')';
          // this.searchText = this.brands[0];
          // this.delegateeSapId = this.recentDelegatee[0].SAPID;
          this.SpinnerService.hide();
        },
        error: err => this.errorMessage = err
      }
    )
  }

  filterBrands(event) {
    this.brands = [''];
    this.brand = [''];
    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      this.filteredBrands.push(this.brands[i]);
      // let brand = this.brands[i];
      // if (brand.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
      //   this.filteredBrands.push(brand);
      // }
    }
  }

  bindRecentDelegatee() {
    this.brands = [];
    for (let i = 0; i < this.recentDelegatee.length; i++) {
      this.brands[i] = this.recentDelegatee[i].EmpName + ' (' + this.recentDelegatee[i].SAPID + ')';
    }
  }

  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  openModal(approvedModal: TemplateRef<void>) {

    this.modalRef = this.modalService.show(approvedModal, this.config);
    document.body.classList.add('modal-open2');
  }

  hideSuccessMsg() {
    document.body.classList.remove('modal-open2');
  }

  ShowMe(meg: string): string {
    return meg;
  }

  onSelectApp(appName: string) {
    // 
    this.listDelegatee = [];
    this.listAddRole = [];
    this.uploadedDoc = [];
    this.createAdvanceDelegation = [];
    //this.selectedApps = [];
    this.DelegatorChecked = false;
    this.hiddenBtn = true;
    // this.selectedSubRoles = [];

    for (let i = 0; i < this.appRoleAndSubRoles.length; i++) {
      if (this.appRoleAndSubRoles[i].AppName == appName) {
        let apps = this.appRoleAndSubRoles[i];
        for (let h = 0; h < apps.CDS_GetRoleAndSubRole.length; h++) {
          this.selectedSubRoles.push(apps.CDS_GetRoleAndSubRole[h]);
          if (apps.AppName == 'AAM' || apps.AppName == 'RAS') {
            this.IsSubRoleApplication = true;
          }
          else {
            this.IsSubRoleApplication = false;
          }
        }
        this.selectedApps.push(apps);
        this.appRoleAndSubRoles.splice(i, 1);
        this.noData = false;
        this.addApps = true;

        // if(this.selectedApps.length==0)
        // {
        //  this.selectedApps.push(apps);
        // }
        // else if(this.selectedApps.length>0)
        // {
        //   this.selectedApps[0]=apps;
        // }

        this.NoOfSelectedApp = this.selectedApps.length;
        // this.appRoleAndSubRoles.splice(i, 1); // Condition to remove the App after selection
      }

    }
  }

  RemoveSelectedApp(event) {
    this.removeAppName = event.target.innerHTML;
    for (let i = 0; i < this.selectedApps.length; i++) {
      if (this.selectedApps[i].AppName.toLocaleLowerCase() == this.removeAppName.toLocaleLowerCase()) {
        this.appRoleAndSubRoles.push(this.selectedApps[i]);
        this.selectedApps.splice(i, 1);
        this.NoOfSelectedApp = this.selectedApps.length;
        this.isCheckAllApp = false;
        if (this.selectedApps.length > 0) {
          this.noData = false;
          this.addApps = true;
        } else {
          this.noData = true;
          this.addApps = false;
          this.isSubmitbuttonshow = false;
        }
      }
    }
  }

  CheckAllApplication(event) {
    if (event.target.checked) {
      for (let i = 0; i < this.appRoleAndSubRoles.length; i++) {
        this.selectedApps.push(this.appRoleAndSubRoles[i]);
        this.NoOfSelectedApp = this.selectedApps.length;
        this.noData = false;
        this.addApps = true;
      }
      this.appRoleAndSubRoles = [];
    } else {
      for (let i = 0; i < this.selectedApps.length; i++) {
        this.appRoleAndSubRoles.push(this.selectedApps[i]);
      }
      this.selectedApps = [];
      this.NoOfSelectedApp = this.selectedApps.length;
      this.noData = true;
      this.addApps = false;
    }
  }

  // Appliction with role 
  addRoleEvent(appId, AppRoleId) {
    this.listSubRoleAsPerRoleSelection = [];
    if (this.listAddRole.find(a => a.RoleId === AppRoleId) === undefined) {
      this.listAddRole.push({ AppId: appId, RoleId: AppRoleId });
      this.isSubmitbuttonshow = true;
    }
    else {
      let indx = this.listAddRole.findIndex(a => a.RoleId === AppRoleId && a.AppId == appId);
      this.listAddRole.splice(indx, 1);
    }

    this.selectedApps.forEach(element => {
      if (element.AppId == appId) {
        element["NoOfSelectedRoleWithoutSubRole"] = this.listAddRole.filter(x => x.AppId == appId).length;
        if (this.listAddRole.length == element.CDS_GetRoleAndSubRole.length) {
          element["SelectAllRoles"] = true;
        } else {
          element["SelectAllRoles"] = false;
        }
      }
    });


    for (let i = 0; i < this.selectedSubRoles.length; i++) {
      if (this.selectedSubRoles[i]["AppRoleID"] == AppRoleId && this.selectedSubRoles[i]["AppId"] == appId) {
        if (this.listSubRoleAsPerRoleSelection.find(a => a.RoleId === AppRoleId) === undefined) {
          this.listSubRoleAsPerRoleSelection.push({ AppId: appId, RoleId: AppRoleId });
          this.NoOfSelectedRoleWithoutSubRole = this.listAddRole.length;
          if (this.selectedSubRoles.length == this.listAddRole.length)
            this.selectedSubRoles[i]["SelectAllRoles"] = true;
          else
            this.selectedSubRoles[i]["SelectAllRoles"] = false;
        }
        else {
          let indx = this.listSubRoleAsPerRoleSelection.findIndex(a => a.RoleId === AppRoleId);
          this.listSubRoleAsPerRoleSelection.splice(indx, 1);
          this.NoOfSelectedRoleWithoutSubRole = this.listAddRole.length;
        }
      }
    }
    this.isSubmitbuttonshow = this.listAddRole.length == 0 ? false : true;//!this.ValidationRoles?false:true;
  }

  SelectAllRole(e, appId) {
    if (e.target.checked) {
      this.selectedApps.forEach(element => {
        if (element.AppId == appId) {
          for (let i = 0; i < element.CDS_GetRoleAndSubRole.length; i++) {
            this.listAddRole.push({ AppId: element.CDS_GetRoleAndSubRole[i].AppId, RoleId: element.CDS_GetRoleAndSubRole[i].AppRoleID });
            element.CDS_GetRoleAndSubRole[i]["checkapp"] = true;
            this.isSubmitbuttonshow = true;
          }
          element["NoOfSelectedRoleWithoutSubRole"] = element.CDS_GetRoleAndSubRole.length;
        }
      });
    } else {
      this.selectedApps.forEach(element => {
        if (element.AppId == appId) {
          for (let i = 0; i < element.CDS_GetRoleAndSubRole.length; i++) {
            element.CDS_GetRoleAndSubRole[i]["checkapp"] = false;
            let ObjListAddRole = { 'AppId': element.CDS_GetRoleAndSubRole[i].AppId, 'RoleId': element.CDS_GetRoleAndSubRole[i].AppRoleID };
            let match = this.listAddRole.filter(x => x.AppId == element.CDS_GetRoleAndSubRole[i].AppId && x.RoleId == element.CDS_GetRoleAndSubRole[i].AppRoleID);
            match ? this.listAddRole.splice(this.listAddRole.indexOf(ObjListAddRole), 1) : null;
            //this.listAddRole.splice(this.listAddRole.filter(x => x.AppId == element.CDS_GetRoleAndSubRole[i].AppId && x.RoleId == element.CDS_GetRoleAndSubRole[i].AppRoleID), 1);
          }
          element["NoOfSelectedRoleWithoutSubRole"] = 0;
        }
      });
      this.isSubmitbuttonshow = false;
    }
  }

  // Invoke on Sub Role Selection
  addSubRoleEvent(appId, roleId, subRoleId, subRoleName, subRoleCode) {
    if (this.listAddSubRole.find(a => a.Subrolid === subRoleId && a.SubRoleCode === subRoleCode) === undefined) {
      this.listAddSubRole.push({ AppId: appId, RollId: roleId, Subrolid: subRoleId, SubRoleName: subRoleName, SubRoleCode: subRoleCode });
      if (this.listAddSubRole.length >= 2) {
        this.removedSubRoleslength.length = this.listAddSubRole.length - 1;// comparing with last listAddSubRole
        const subRoleExists = this.removedSubRoleslength.some(x => x.RollId === roleId &&
          ((subRoleId && x.Subrolid === subRoleId) || (subRoleCode && x.SubRoleCode === subRoleCode)));
        const roleExists = this.listAddRole.some(x => x.RoleId === roleId);

        if (!subRoleExists && !roleExists) {
          this.listAddRole.push({ AppId: appId, RoleId: roleId });
        }
      }
      else {
        this.listAddRole.push({ AppId: appId, RoleId: roleId });
      }
      this.isSubmitbuttonshow = true;
    }
    else {
      let indx = this.listAddSubRole.findIndex(a => a.Subrolid === subRoleId || a.SubRoleCode === subRoleCode);
      this.listAddSubRole.splice(indx, 1);
    }

    if (this.listAddSubRole.length == 0) {
      let indx = this.listAddRole.findIndex(a => a.AppId == appId && a.RoleId == roleId);
      this.listAddRole.splice(indx, 1);
    }

    this.selectedApps.forEach(element => {
      if (element.AppId == appId) {
        element["NoOfSelectedRoleWithoutSubRole"] = this.listAddSubRole.filter(x => x.AppId == appId).length;
        if (this.listAddSubRole.filter(x => x.RollId == roleId).length == element.CDS_GetRoleAndSubRole.filter(x => x.AppRoleID == roleId)[0]['SubRoleName'].length) {
          element.CDS_GetRoleAndSubRole.filter(x => x.AppRoleID == roleId)[0]['SelectAllRoles'] = true;
        } else
          element.CDS_GetRoleAndSubRole.filter(x => x.AppRoleID == roleId)[0]['SelectAllRoles'] = false;
      }
    });

  }

  //Select all sub roles with appliaction
  SelectAllWithSubRole(e, appId, AppRoleId) {

    if (this.listAddRole.find(a => a.RoleId === AppRoleId) === undefined) {
      this.listAddRole.push({ AppId: appId, RoleId: AppRoleId });
    }
    else {
      let indx = this.listAddRole.findIndex(a => a.RoleId === AppRoleId);
      this.listAddRole.splice(indx, 1);
    }

    if (e.target.checked) {
      this.isSubmitbuttonshow = true;
      for (let i = 0; i < this.selectedSubRoles.length; i++) {
        if (this.selectedSubRoles[i]["AppRoleID"] == AppRoleId && this.selectedSubRoles[i]["AppId"] == appId) {
          if (this.listSubRoleAsPerRoleSelection.find(a => a.RoleId === AppRoleId) === undefined) {
            this.listSubRoleAsPerRoleSelection.push({ AppId: appId, RoleId: AppRoleId });
            this.selectedSubRoles[i].SubRoleName.forEach(x => {
              x["checkapp"] = true;
              this.listAddSubRole.push({ AppId: x.AppId, RollId: x.RollId, Subrolid: x.Subrolid, SubRoleName: x.SubRoleName, SubRoleCode: x.SubRoleCode });
            });
          }
        }
      }
      this.selectedApps.forEach(element => {
        if (element.AppId == appId) {
          element["NoOfSelectedRoleWithoutSubRole"] = this.listAddSubRole.length;
        }
      });
    }
    else {
      this.selectedApps.forEach(element => {
        if (element.AppId == appId) {
          for (let i = 0; i < element.CDS_GetRoleAndSubRole.length; i++) {
            element.CDS_GetRoleAndSubRole[i]["checkapp"] = false;
            for (let i = 0; i < this.selectedSubRoles.length; i++) {
              if (element.CDS_GetRoleAndSubRole[i].AppRoleID == AppRoleId && element.CDS_GetRoleAndSubRole[i].AppId == appId) {
                if (this.listSubRoleAsPerRoleSelection.find(a => a.RoleId === AppRoleId) != undefined) {
                  let indx = this.listSubRoleAsPerRoleSelection.findIndex(a => a.AppId === appId && a.RoleId === AppRoleId);
                  this.listSubRoleAsPerRoleSelection.splice(indx, 1);
                  this.selectedSubRoles[i].SubRoleName.forEach(x => {
                    x["checkapp"] = false;
                    let ind = this.listAddSubRole.findIndex(a => a.Subrolid === x.Subrolid && a.RollId === AppRoleId);
                    this.listAddSubRole.splice(ind, 1);
                  });
                }
              }
            }
          }
          element["NoOfSelectedRoleWithoutSubRole"] = this.listAddSubRole.length;
        }
      });
    }
    this.ValidationRoles = this.listAddRole.length == 0 ? true : false;
  }

  onDatesRangeFilterSelected() {
    let thirtyday = (d => new Date(d.setDate(d.getDate() + 30)))(new Date);
    if (this.ingredient == "1-Month") {
      thirtyday = (d => new Date(d.setDate(d.getDate() + 30)))(new Date);
      this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd/MMM/yyyy');

    } else if (this.ingredient == "3-Month") {
      thirtyday = (d => new Date(d.setDate(d.getDate() + 90)))(new Date);
      this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd/MMM/yyyy');
      this.myDatestring = this.datePipe.transform(this.myDate, 'dd/MMM/yyyy');
      let date1 = new Date(thirtyday);
      let date2 = new Date(this.myDatestringthritydays);
      this.DelegationStartDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
      this.DelegationEndDatetime = this.datePipe.transform(date2, 'yyyy-MM-dd');
    } else if (this.ingredient == "1-Year") {
      thirtyday = (d => new Date(d.setDate(d.getDate() + 365)))(new Date);
      this.myDatestringthritydays = this.datePipe.transform(thirtyday, 'dd/MMM/yyyy');
      let date1 = new Date(thirtyday);
      let date2 = new Date(this.myDatestringthritydays);
      this.DelegationStartDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
      this.DelegationEndDatetime = this.datePipe.transform(date2, 'yyyy-MM-dd');
    }
    this.AdvanceDateRangeFilter = [new Date, thirtyday];
  }

  onAdvanceRemarks(event, appId) {
    if (event != "" && event != " ") {
      this.listRemarks.push({ remarksText: event, appId: appId });
    }
    else {
      for (var i = this.listRemarks.length; i--;) {
        if (this.listRemarks[i].appId === appId) {
          this.listRemarks.splice(i, 1);
        }
      }
    }
    //console.log(this.listRemarks);
  }

  onAdvanceRemarksToggle(event) {
    if (event != "" && event != " ") {
      this.listRemarks['remarksText'] = event
    }
    else {
      this.listRemarks.splice(1);
    }
  }

  // final method to submit the role and sub-roles
  dataSubmitfunction() {
    this.SpinnerService.show();
    this.advancedDelService.addAdvanceDelegationRequest(this.createAdvanceDelegation).subscribe((res) => {

      this.copyreqStatusRemarks = '';
      this.reqStatusRemarks = '';
      this.reqSubmitMessage = [];
      if (res === null || res === '') {
        this.SpinnerService.hide();
        this.reqStatusRemarks = 'There is some Error! Please try Again';
        this.showSuccess();
        catchError(this.advancedDelService.handleError);
      }
      else {
        this.reqSubmitMessage.push(res);
        //this.reqStatusRemarks = res.StatusRemarks;
        this.reqStatusRemarks = res.StatusRemarks.substring(0, res.StatusRemarks.length - 1);
        //console.log("remarks", this.reqStatusRemarks)
        this.SpinnerService.hide();

        if (res.DelReqid != 0) {
          this.loginService.pullEncryptValue(this.global.UserLoggedInSAPID).subscribe(res => {

            //  
            if (res.clearText != "" && this.reqSubmitMessage[0].StatusCode != 2) {
              this.loginService.isEncrypted = true;
              //   
              this.encValues = res.clearText;
              this.encAppId = "/CmHtkGSJ91DqNC1Wxq0Hg=="; //42  DelReqid
              this.encDelReqID = (this.reqSubmitMessage[0].EncDelReqid === null || this.reqSubmitMessage[0].EncDelReqid === "") ? this.encValues : this.reqSubmitMessage[0].EncDelReqid;
              this.url = "https://wf33.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encDelReqID + "&&ApplicationID=" + this.encAppId + "&&EmployeeID=" + this.encValues, "pop", "status=no,height=200,width=600,resizable=no,left=400,top=100,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false";
              //window.open("https://wf33.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encDelReqID + "&&ApplicationID=" + this.encAppId + "&&EmployeeID=" + this.encValues, "pop", "status=no,height=200,width=600,resizable=no,left=400,top=600,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false").focus();                       
              this.win.open(this.url);
            }
          })
          this.alert(this.templateapprovedModal);
          setTimeout(() => {
            this.removeModal();
            this.router.navigate(['/approval']);
          }, 10000);
        } else {
          this.errorOndehalfDelegation = '';
          //this.errorOndehalfDelegation = res.StatusRemarks;
          let delegation = res.StatusRemarks.substring(0, res.StatusRemarks.length - 1);
          this.errorOndehalfDelegationMultiError = delegation.split(',');

          this.openModal(this.templateSuccErrorModalMultiLine);
        }
      }
      // window.location.reload();
    },
      (error: Response) => {
        //if(error.status === 404)
        alert('Please try with other options');
        // else {  
        //   alert('An Unexpected Error Occured.');  

        // }
        // window.location.reload();   
      }
    );

  }

  onSubmit() {
    this.createAdvanceDelegation = [];
    if (this.listDelegatee.length > 0) {

      if (this.DelegatorChecked == false) {
        this.visible = true;
        this.errorOnAdvDelegation = "Provide Delegator Consent";
        return;
      }

      if (this.DelegationStartDate !== "") {
        for (let i = 0; i < this.listAddRole.length; i++) {
          const addAdvanceRequest = <addAdvanceRequest>
            {
              AppId: this.listAddRole[i].AppId,
              RoleId: this.listAddRole[i].RoleId,
              RequesterSAPId: this.RequesterSAPId,
              DelegateeSAPId: this.listDelegatee.length > 1 ? this.listDelegatee.find(del => del.appId === this.listAddRole[i].AppId).delegateeId.toString() : this.listDelegatee[0].delegateeId.toString(),
              DelegationEndDatetime: this.DelegationEndDatetime,
              DelegationStartDate: this.DelegationStartDate,

              Remarks: this.listRemarks.length > 0 ? this.listRemarks.find(remarks => remarks.appId === this.listAddRole[i].AppId).remarksText : this.advancedRemarks,
              ActionBy: this.ActionBy,
              touchDate: this.touchDate,
              RequestStatus: "PRM",
              ValidationErrorMsg: 'Y',
              SubRole: [
                {
                  AppId: this.listAddRole[i].AppId,
                  RollId: this.listAddRole[i].RoleId,
                  Subrolid: 0,
                  SubRoleName: null,
                  SubRoleCode: null
                }
              ],
              DelegatorConsen: this.DelegatorChecked
            }
          this.createAdvanceDelegation.push(addAdvanceRequest);
        }

        for (let i = 0; i < this.createAdvanceDelegation.length; i++) {
          this.createAdvanceDelegation[i].SubRole.splice(0, 1);
          if (this.remarkchecked) {
            this.createAdvanceDelegation[i].Remarks = this.advancedRemarks;
          }
          if (this.listchkWF.length >= i && this.listchkWF[i] != undefined) {
            this.createAdvanceDelegation[i].IsWFBypass = this.listchkWF.find(WF => WF.appId === this.listAddRole[i].AppId).chkWF;
          }
          else {
            this.createAdvanceDelegation[i].IsWFBypass = false;
          }
          if (this.listRemarks.length >= i && this.listRemarks[i] != undefined) {
            this.createAdvanceDelegation[i].Remarks = this.listRemarks.find(remarks => remarks.appId === this.listAddRole[i].AppId).remarksText;
          }
          else {
            this.createAdvanceDelegation[i].Remarks = null;
          }

          for (let k = 0; k < this.listSubRoleAsPerRoleSelection.length; k++) {
            if (this.createAdvanceDelegation[i].AppId === this.listSubRoleAsPerRoleSelection[k]["AppId"] && this.createAdvanceDelegation[k].RoleId === this.listSubRoleAsPerRoleSelection[k]["AppRoleID"] && this.listSubRoleAsPerRoleSelection[k].SubRoleName.length > 0) {
              if (this.listAddSubRole.length == 0) {
                this.validRequest = false;
                // this.alert(this.templateSubRole);
                this.ValidationSubRoles = true;
                return;
              }
              else {
                if (this.listAddSubRole.find(a => a.RollId === this.listSubRoleAsPerRoleSelection[k]["AppRoleID"]) === undefined) {
                  //alert("Please select Sub role");
                  this.validRequest = false;
                  //this.alert(this.templateSubRole);
                  this.ValidationSubRoles = false;
                  return;
                }
                if (this.listAddSubRole.find(a => a.RollId === this.listSubRoleAsPerRoleSelection[k]["AppRoleID"]).RollId !== this.createAdvanceDelegation[k].RoleId) {

                  //alert("Please select Sub role");
                  this.validRequest = false;
                  //this.alert(this.templateSubRole);
                  this.ValidationSubRoles = true;
                  return;

                }
              }

            }

          }
          for (let j = 0; j < this.listAddSubRole.length; j++) {

            if (this.createAdvanceDelegation[i].AppId === this.listAddSubRole[j].AppId && this.createAdvanceDelegation[i].RoleId === this.listAddSubRole[j].RollId) {
              this.createAdvanceDelegation[i].SubRole.push(this.listAddSubRole[j]);
            }
          }

        }
        if (this.createAdvanceDelegation.length > 0) {
          this.rejectModal.show();
        }
        else {
          this.visible = true;
          this.errorOnAdvDelegation = "Check Roles";
        }

      }
      else {
        this.validRequest = false;
        this.alert(this.templateDate);
      }
    }
    else {
      //this.ValidationRoles = this.listAddRole.length == 0 ? true : false;
      this.visible = true;
      this.errorOnAdvDelegation = "Select Delegatee";
      // this.alert(this.templateRefsubmit2);
    }
  }

  OnClickDelegative(e) {

  }

  OnKeyUpDelegative(event, appId) {


    this.searchText = event.target.value;
    if (this.searchText.length > 3) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.searchText
        }
      this.advancedDelService.fetchDelegateeSuggestions(sapId).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;

          },
          error: err => this.errorMessage = err
        });
    }

    if (this.searchText == "") {
      for (var i = this.listDelegatee.length; i--;) {
        if (this.listDelegatee[i].appId === appId) { this.listDelegatee.splice(i, 1); }
      }
    }
    //console.log(this.listDelegatee);
  }

  OnKeyUpDelegativeToggle(event) {
    //console.log(event.target.value);
    this.searchText = event.target.value;
    if (this.searchText.length > 3) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.searchText
        }
      this.advancedDelService.fetchDelegateeSuggestions(sapId).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;

          },
          error: err => this.errorMessage = err
        });
    }

    if (this.searchText == "") {
      this.listDelegatee.splice(1);
    }
    //console.log(this.listDelegatee);
  }

  updateAdvanceDelegatee(event, appId) {
    this.delegateeSapId = this.searchText.toString().substring(this.searchText.toString().length - 9, this.searchText.toString().length - 1);

    for (var i = this.listDelegatee.length; i--;) {
      if (this.listDelegatee[i].appId === appId) { this.listDelegatee.splice(i, 1); }
    }
    this.ValidationSelectDelegetee = false;
    this.listDelegatee.push({ appId: appId, delegateeId: this.delegateeSapId });

  }

  updateAdvanceDelegateeToggle(event) {
    this.delegateeSapId = this.searchText.toString().substring(this.searchText.toString().length - 9, this.searchText.toString().length - 1);
    //console.log(this.delegateeSapId);
    this.listDelegatee.splice(1);
    this.ValidationSelectDelegetee = false;
    //console.log(this.listDelegatee);
  }


  onDelegatorchecked(event) {
    this.DelegatorChecked = event;
    if (this.DelegatorChecked == true) {
      this.DelegatorConsen = false;
    }
    else {
      this.DelegatorConsen = true;
    }
  }

  moveDate() {
    this.DelegationStartDate = this.datePipe.transform(this.AdvanceDateRangeFilter[0], 'yyyy-MM-dd');
    this.DelegationEndDatetime = this.datePipe.transform(this.AdvanceDateRangeFilter[1], 'yyyy-MM-dd');
  }

  removeModal() {
    this.modalService.hide(1);
    document.body.classList.add('modal-open2');
  }

  reloadWindow() {
    setTimeout(() => {
      this.router.navigate(['/approval']);
    }, 100);
  }

  OnClick() {
    this.visible = false;
  }
}